const apiProxy = require('../api/apiProxy');
const stateManager = require('../state/stateManager');
const configurationManager = require('../config/configurationManager');
const logger = require('../logger/logger');
const stringUtil = require('../string/stringUtil');

export function addCustomerAuditLog(module, objectId, objectIdentifier, auditAction, message, status, auditBlob, stackTrace)
{
    const user = getCustomerIdentifier();
    addAuditLog(user, module, objectId, objectIdentifier, auditAction, message, status, auditBlob, stackTrace);
}

export function addAuditLog(user, module, objectId, objectIdentifier, auditAction, message, status, objectBlob, stackTrace)
{
    try
    {
        const state = stateManager.getStore().getState();
        const appConfig = configurationManager.getAppConfig();

        const auditEntity = {
            franchisorId: state.franchisor?.id || state.franchisorId,
            franchiseeId: state.franchisee?.id || state.franchiseeId,
            propertyId: state.property?.id || state.propertyId,
            user: user,

            module: module,
            objectId: objectId,
            objectIdentifier: objectIdentifier,
            auditAction: auditAction,
            auditMessage: message,
            auditStatus: status,

            auditBlob: {
                service: 'RMS.APP.CUSTOMER.WEB',
                env: appConfig?.environment,
                version: appConfig?.version,
                data: objectBlob,

                applicationId: state.applicationId,
                applicationTitle: state.applicationTitle,
                channel: state.channel,
                currentMode: state.currentMode,
                tableNumber: state.tableNumber,
                venueCode: state.venueCode,
                paymentLinkId: state.paymentLinkId,
            },
            stackTrace: stackTrace,
        };

        publishAuditLog(auditEntity);
    }
    catch (error)
    {
        logger.error(`Error occurred while building audit log message. ${error}`, null, error);
    }
}

function publishAuditLog(auditEntity)
{
    apiProxy.postAudit('gateway/audits', auditEntity)
        .catch(error =>
        {
            logger.error(`Failed to publish audit log. ${error}`, null, error);
        });
}

function getCustomerIdentifier()
{
    const user = stateManager.getStore().getState().user;
    if (user != null)
    {
        if (!stringUtil.isStringNullOrEmpty(user.name)) return user.name;
        if (!stringUtil.isStringNullOrEmpty(user.phoneNumber)) return user.phoneNumber;
        if (!stringUtil.isStringNullOrEmpty(user.emailAddress)) return user.emailAddress;
    }
    return 'Customer Web';
}
